/** AG Grid row-id field; client-side only, never sent to the API. */
export const REPORT_ROW_ID = '__report_row_id';
